var _path, _path2, _path3, _g, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M215.864 256.006L0 399.911V112.089zM512 112.089v287.822L296.136 256.006z",
  fill: "#6da544"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M512 112.089L296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512 112.089L296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 74.207
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M256 204.058l6.426 11.13h12.852l-6.426 11.13 6.426 11.131h-12.852L256 248.579l-6.426-11.13h-12.852l6.426-11.131-6.426-11.13h12.852zM223.337 256l6.425 11.13h12.853l-6.426 11.131 6.426 11.13h-12.853l-6.425 11.131-6.427-11.131h-12.852l6.426-11.13-6.426-11.131h12.852zm65.326 0l6.427 11.13h12.852l-6.426 11.131 6.426 11.13H295.09l-6.427 11.131-6.425-11.131h-12.853l6.426-11.13-6.426-11.131h12.853z",
  fill: "#d80027"
})));

export default SvgBi;